module.exports = __webpack_public_path__ + "static/media/tooltip_bg_bottom.443b5e4f.svg";